import React from "react";
import { Button } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const TonalButtonDisabled = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"Disabled Tonal button"}
        value={'<Button variant={"tonal"} disabled>Disabled</Button>'}
      >
        <Button variant={"tonal"} disabled>
          Disabled
        </Button>
      </PreviewAndEditor>
    </>
  );
};

export default TonalButtonDisabled;
